import { BTable, BFormInput } from "bootstrap-vue";

export default {
  name: "levelSettings",
  components: {
    BTable,
    BFormInput,
  },

  data() {
    return {
      disabled: false,
      url: "admin/customers_club/get_user_levels",
      editUrl: "admin/customers_club/set_user_levels",
      items: [],
      fields: [
        {
          label: "شناسه",
          key: "id",
        },
        {
          label: "عنوان",
          key: "title",
        },
        {
          label: "حداقل امتیاز",
          key: "min_score",
        },
        {
          label: "حداکثر امتیاز",
          key: "max_score",
        },
        {
          label: "رنگ",
          key: "color",
        },
        {
          label: "مقدار بازگشت به کیف پول ",
          key: "permanent_purchase_discount",
        },
        {
          label: "تخفیف محصول (درصد)",
          key: "coupon_discount_percentage",
        },
        {
          label: "تخفیف تولد",
          key: "birthdate_discount",
        },
        {
          label: "ارسال رایگان",
          key: "free_shipping",
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.disabled = true;
      await this.$axios
        .get(this.url)
        .then((res) => {
          this.items = res.data.data.list;
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    async submitChanges() {
      this.disabled = true;
      await this.$axios
        .put(this.editUrl, { customers_club_user_levels: [...this.items] })
        .then((res) => {
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
